/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  GetLedgerBalancesByUserIDOptions,
  GetLedgerBalancesByUserIDStatus200,
  GetLedgerBalancesByUserIDStatus400,
  GetLedgerBalancesByUserIDStatus404,
  GetLedgerBalancesByUserIDStatus500,
} from '../types/GetLedgerBalancesByUserID'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { getLedgerBalancesByUserID } from '../clients/getLedgerBalancesByUserID'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getLedgerBalancesByUserIDQueryKey = ({
  path,
  query,
}: Omit<GetLedgerBalancesByUserIDOptions, 'headers'>) =>
  [{ url: '/v1/ledger/balances/:user_id', params: path }, ...(query ? [query] : [])] as const

type GetLedgerBalancesByUserIDQueryKey = ReturnType<typeof getLedgerBalancesByUserIDQueryKey>

export function getLedgerBalancesByUserIDQueryOptions(
  { path, query }: GetLedgerBalancesByUserIDOptions,
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const queryKey = getLedgerBalancesByUserIDQueryKey({ path, query })
  return queryOptions<
    GetLedgerBalancesByUserIDStatus200,
    ResponseErrorConfig<
      | GetLedgerBalancesByUserIDStatus400
      | GetLedgerBalancesByUserIDStatus404
      | GetLedgerBalancesByUserIDStatus500
    >,
    GetLedgerBalancesByUserIDStatus200,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getLedgerBalancesByUserID({
        ...config,
        path,
        query,
        signal: config.signal ?? signal,
        throwOnError: true,
      }).unwrap()
    },
  })
}

/**
 * @summary Get a specific user's available, locked, and borrowed assets
 * {@link /v1/ledger/balances/:user_id}
 */
export function useGetLedgerBalancesByUserID<
  TData = GetLedgerBalancesByUserIDStatus200,
  TQueryData = GetLedgerBalancesByUserIDStatus200,
  TQueryKey extends QueryKey = GetLedgerBalancesByUserIDQueryKey,
>(
  {
    path,
    query,
  }: {
    path:
      | GetLedgerBalancesByUserIDOptions['path']
      | (() => GetLedgerBalancesByUserIDOptions['path'])
    query?:
      | GetLedgerBalancesByUserIDOptions['query']
      | (() => GetLedgerBalancesByUserIDOptions['query'])
  },
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetLedgerBalancesByUserIDStatus200,
        ResponseErrorConfig<
          | GetLedgerBalancesByUserIDStatus400
          | GetLedgerBalancesByUserIDStatus404
          | GetLedgerBalancesByUserIDStatus500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const resolvedParams = {
    path: typeof path === 'function' ? path() : path,
    query: typeof query === 'function' ? query() : query,
  }
  const queryKey = resolvedOptions?.queryKey ?? getLedgerBalancesByUserIDQueryKey(resolvedParams)

  const queryResult = useQuery(
    {
      ...getLedgerBalancesByUserIDQueryOptions(resolvedParams, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetLedgerBalancesByUserIDStatus400
      | GetLedgerBalancesByUserIDStatus404
      | GetLedgerBalancesByUserIDStatus500
    >
  > & { queryKey: TQueryKey }

  queryResult.queryKey = queryKey as TQueryKey

  return queryResult
}
